import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content-skeleton',
  templateUrl: './content-skeleton.component.html',
  styleUrls: ['./content-skeleton.component.css']
})
export class ContentSkeletonComponent {
  @Input() type: string = 'home';
}
